namespace Gordic.Epk.WebControls.Vyrizeni {


    //#region *** NÁZEV VYŘÍZENÍ ***

    export class NazevVyrizeni {

        /** vrátit název */
        public getName(zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum, typPozadavku: Gordic.Wfl.Interface.TypPozadavkuEpk): string {
            if (zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani) {
                return "jres:32000430";                 //RC 32000430 : vrácení k přepracování
            }
            else {
                /** popisek */
                var caption = "";
                switch (typPozadavku) {

                    case Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni:
                        caption = "jres:32000647";      //RC 32000647 : schválení přidělení
                        break;
                    case Gordic.Wfl.Interface.TypPozadavkuEpk.Predani:
                        caption = "jres:32000648";      //RC 32000648 : schválení předání
                        break;
                    case Gordic.Wfl.Interface.TypPozadavkuEpk.SchvalitVyrizeniSpisu:
                        caption = "jres:32000649";      //RC 32000649 : schválení vyřízení spisu
                        break;

                    case Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat:
                        caption = "jres:32000435";      //RC 32000435 : podepsání
                        break;
                    case Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit:
                        caption = "jres:32000434";      //RC 32000434 : podepsání a schválení
                        break;
                    case Gordic.Wfl.Interface.TypPozadavkuEpk.Schvalit:
                        caption = "jres:32000431";      //RC 32000431 : schválení
                        break;
                    case Gordic.Wfl.Interface.TypPozadavkuEpk.Posoudit:
                        caption = "jres:32000432";      //RC 32000432 : posouzení
                        break;
                    case Gordic.Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi:
                        caption = "jres:32000433";      //RC 32000433 : vzetí na vědomí
                    case Gordic.Wfl.Interface.TypPozadavkuEpk.Splnit:
                        caption = "jres:32000436";      //RC 32000436 : splnění
                        break;
                    case Gordic.Wfl.Interface.TypPozadavkuEpk.Rozhodnout:
                        caption = "jres:32000451";      //RC 32000451 : Rozhodnutí
                        break;
                    default:
                        break;
                }
                return caption;
            }
        }

    }

    //#endregion

}